module.exports = __webpack_public_path__ + "static/img/COL.d8b821a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/COL.svg
// module id = kpPL
// module chunks = 1